import type { ProductSlimResponseDTO } from '@shared/DTO';
import { createDomElementHandler as el } from '@/scripts/utils/dom.utils';
import { createStandaloneProductCardViewModel } from '../ab-products/variants/productListingItem';
import type { ProductCardViewModel } from '../ab-products/variants/purchaseCta.types';
import { PurchaseCtaView } from '../purchase-cta/purchaseCta.view';
import { resolveProductContent, ProductContentInputs, ProductContentImage } from '../product-content/productContent.model';
import './abProductAffiliateBox.style.scss';

export class AbProductAffiliateBoxElement extends HTMLElement {
  #model?: ProductCardViewModel;
  #content: ProductContentInputs = {};
  #cta?: PurchaseCtaView;

  connectedCallback() { this.#cta?.connect(); }
  disconnectedCallback() { this.#cta?.disconnect(); }

  get product(): ProductSlimResponseDTO | undefined { return this.#model?.product; }
  set product(value: ProductSlimResponseDTO | undefined) { this.cardModel = value ? createStandaloneProductCardViewModel(value) : undefined; }
  get cardModel(): ProductCardViewModel | undefined { return this.#model; }
  set cardModel(value: ProductCardViewModel | undefined) { this.#model = value; this.#render(); }

  get productTitle() { return this.#content.title; }
  set productTitle(value: string | null | undefined) { this.#content.title = value; this.#render(); }
  get image() { return this.#content.image; }
  set image(value: ProductContentImage | null | undefined) { this.#content.image = value; this.#render(); }
  get descriptionPoints() { return this.#content.descriptionPoints; }
  set descriptionPoints(value: readonly string[] | null | undefined) { this.#content.descriptionPoints = value; this.#render(); }

  #render() {
    this.#cta?.disconnect(); this.#cta = undefined;
    if (!this.#model) { this.replaceChildren(); return; }
    const content = resolveProductContent(this.#model.product, this.#content);
    const root = el('div', 'ab-affiliate-box');
    const inner = el('div', 'ab-affiliate-box__inner');
    if (content.image) {
      const wrapper = el('div', 'ab-affiliate-box__image-wrapper');
      wrapper.append(el('img', 'ab-product-affiliate-box__image', { src: content.image.url, alt: content.image.alt, loading: 'lazy', decoding: 'async' }));
      inner.append(wrapper);
    }
    const info = el('div', 'ab-affiliate-box__info-wrapper');
    if (content.title !== undefined) { const heading = el('h3', 'ab-affiliate-box__title'); heading.textContent = content.title; info.append(heading); }
    if (content.descriptionPoints?.length) {
      const list = el('ul', 'ab-affiliate-box__description-list');
      content.descriptionPoints.forEach((point) => { const item = el('li', 'ab-affiliate-box__description-item'); item.textContent = point; list.append(item); });
      info.append(list);
    }
    this.#cta = new PurchaseCtaView(this.#model.purchaseCta, { unavailableLabel: 'Non disponibile' });
    const button = el('div', 'ab-affiliate-box__button-wrapper'); button.append(this.#cta.element);
    info.append(button); inner.append(info); root.append(inner); this.replaceChildren(root);
    if (this.isConnected) this.#cta.connect();
  }
}

export function defineAbProductAffiliateBoxElement() {
  if (!customElements.get('ab-product-affiliate-box')) customElements.define('ab-product-affiliate-box', AbProductAffiliateBoxElement);
}
